
import { useEffect } from 'react';
import { AxiosInstance } from 'axios';
import { InternalAxiosRequestConfig } from 'axios';
import { getRefreshToken } from '@/utils/readToken';
import { applyWebsiteScopeHeaders } from '@/lib/websiteScope';

export const useAxiosInterceptors = (
  api: AxiosInstance,
  refreshAccessToken: (refreshToken: string) => Promise<string>
) => {
  useEffect(() => {
    const reqId = api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
      const access = localStorage.getItem('admin_access_token');
      if (config.headers) {
        Object.assign(config.headers, applyWebsiteScopeHeaders({}));
        if (access) {
          config.headers['Authorization'] = `Bearer ${access}`;
        }
      }
      return config;
    });

    const resId = api.interceptors.response.use(
      (res) => res,
      async (error) => {
        const original = error.config;
        if (
          error.response?.status === 401 &&
          !original?._retry
        ) {
          original._retry = true;
          try {
            const refreshToken = getRefreshToken();
            if (!refreshToken) {
              throw new Error("No refresh token available");
            }
            
            const newAccess = await refreshAccessToken(refreshToken);
            original.headers = {
              ...original.headers,
              Authorization: `Bearer ${newAccess}`,
            };
            return api(original);
          } catch (refreshErr) {
            return Promise.reject(refreshErr);
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      api.interceptors.request.eject(reqId);
      api.interceptors.response.eject(resId);
    };
  }, [api, refreshAccessToken]);
};
